<template>
    <div id="modal-set-company-detail" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5><i class="fas fa-cog icon-size"></i>&nbsp;設定</h5>
                    <button class="close" type="button" @click="closeThis">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row mb-2">
                            <div class="col-6">招待権限</div>
                            <div class="col p-0">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" v-model="can" class="custom-control-input" id="customSwitch1">
                                    <label class="custom-control-label" for="customSwitch1">{{this.canLable}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pt-2">招待可能人数</div>
                            <div class="col p-0">
                                <select class="form-control" v-model="cnt" :disabled="cntDisabled">
                                    <option v-if="!can" value="0">0人</option>
                                    <option v-for="(n,index) in 30" :key="index" :value="n" :selected="n == 5">{{n}}人</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger" type="button" @click="setCompanyInviteDetail">
                        <i class="fas fa-save"></i>&nbsp;登録
                    </button>
                    <button class="btn btn-primary" type="button" @click="closeThis">
                        <i class="fas fa-arrow-alt-circle-left"></i>&nbsp;戻る
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                can: true,
                cnt: 5,
                id: null,
                group: null
            }
        },
        watch: {
            can () {
                if (this.cnt == 0 && this.can) {
                    this.cnt = 1
                }
            },
            getCompanyInviteDetailChangeStatus () {
                if (this.getCompanyInviteDetailChangeStatus == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (this.getCompanyInviteDetailChangeStatus == 2) {
                    this.closeThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (this.getCompanyInviteDetailChangeStatus == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            canLable () {
                return this.can ? '可能' : '不可'
            },
            cntDisabled () {
                return !this.can
            },
            ...mapGetters(['getCompanyInviteDetailChangeStatus'])
        },
        methods: {
            setCompanyInviteDetail () {
                this.$store.dispatch('companyInviteDetailChange', {
                    id: this.id,
                    can: this.can ? '0' : '1',
                    cnt: this.cnt,
                    group: this.group
                })
            },
            openThis (can, cnt, id, group) {
                this.can = can == '0' ? true : false
                this.cnt = cnt
                this.id = id
                this.group = group
                $('#modal-set-company-detail').modal('show')
            },
            closeThis () {
                this.resetThis()
                $('#modal-set-company-detail').modal('hide')
            },
            resetThis () {
                this.can = true
                this.cnt = 5
                this.id = null
                this.group = null
            }
        },
    }
</script>

<style></style>
